// ISO 639-1 http://www.loc.gov/standards/iso639-2/php/code_list.php

export const LOCALES = {
    ENGLISH: 'en',
    WELSH: 'cy'
};
